module.exports = __webpack_public_path__ + "img/brands.da73b52.svg";